import { Product } from '../../types/products';
import { IMAGE_CDN } from 'src/redux/api/appConst';

const ProductCard = ({product, onSelect}: {product: Product, onSelect: (product: Product) => void}) => {
  return (
    <div
      key={product.id}
      className="bg-white rounded-3xl shadow-sm border border-slate-100 overflow-hidden flex flex-col hover:shadow-xl transition-all group cursor-pointer"
      onClick={() => onSelect(product)}
    >
      <div className="relative h-48 overflow-hidden bg-slate-50 p-4">
        <img
          src={`${IMAGE_CDN}/${product.thumbnail}`}
          alt={product.name}
          className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
        />
      </div>
      <div className="p-6">
        <p className="text-[10px] font-black text-emerald-600 uppercase tracking-widest mb-1">
          {product.category}
        </p>
        <h4 className="text-lg font-bold text-slate-800 line-clamp-1 cursor-pointer hover:text-emerald-600 transition-colors">
          {product.name}
        </h4>
        <p className="text-[10px] font-black text-emerald-600 uppercase tracking-widest mb-1">
          {product.sub_category}
        </p>
        <div className="flex justify-between items-center mt-2">
          <p className="text-xl font-black text-slate-900">₹{product.price}</p>
          {/* <Badge
            className={`px-1 py-0 h-fit rounded-full text-[10px] font-black tracking-widest ${product.stockQuantity === 0 ? "bg-rose-500 text-white" : "bg-emerald-500 text-white"}`}
          >
            {product.stockQuantity === 0
              ? "SOLD OUT"
              : `${product.stockQuantity} IN STOCK`}
          </Badge> */}
        </div>
      </div>
    </div>
  );
}

export default ProductCard